import React, { useEffect } from 'react';
import './config/ReactotronConfig';

import TagManager from 'react-gtm-module';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import moment from 'moment';
import 'moment/locale/pt-br';

import { store, persistor } from './store';
import { theme, Root } from './theme/globalStyles';

import ErrorBoundary from './components/ErrorBoundary';
import Routes from './routes';

import projectPackage from '../package.json';

moment.locale('pt-BR');

const isProduction = process.env.REACT_APP_IS_JUMP_PRODUCTION == 'true';

Sentry.init({
  dsn: 'https://31245d68b9dd427b81cf33d41f59c1a4@sentry.io/2274907',
  environment: isProduction ? 'production' : 'staging',
  release: projectPackage.version,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  debug: true,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.replayCanvasIntegration(),
    Sentry.httpClientIntegration({
      failedRequestStatusCodes: [500]
    }),
    Sentry.reportingObserverIntegration({
      types: ['crash']
    })
  ],
  ignoreErrors: [
    'Non-Error promise rejection captured',
    'Non-Error exception captured'
  ],
  denyUrls: [
    /googletagmanager\.com/i,
    /google-analytics\.com/i,
    /www\.google\.com/i,
    /recaptcha/i
  ],
  beforeSend(event, hint) {
    const error = hint?.originalException;

    if(error?.response?.status == 400) {
      return null;
    }

    return event;
  }
});

console.error = () => {};
console.warn = () => {};

const App = () => {
  useEffect(() => {
    TagManager.initialize({ gtmId: 'GTM-KK99ZT6' });
  }, []);

  return (
    <Provider store={store}>
      <ErrorBoundary>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={theme}>
            <Root>
              <CssBaseline />
              <Routes />
            </Root>
          </ThemeProvider>
        </PersistGate>
      </ErrorBoundary>
    </Provider>
  );
}

export default App;